<template>
  <el-row>
      <h1 style="text-align:left;margin-top:unset;">Invoice Generate</h1>
        <hr>
    <el-col :span="24">
      <el-row type="flex" align="middle">
        <el-col class="text-md-left" :span="12" style="margin-bottom:5px;">
          <el-button type="primary" @click="gotoUpload">เพิ่มรายการ</el-button>
          <el-button type="primary" @click="goClearRunningNumber">Clear Running Number</el-button>
        </el-col>
      </el-row>
      <el-card shadow="never">
        <el-row>
          <el-col class="text-md-left" :span="12">
            <el-form label-position="left" label-width="120px" @submit.native.prevent="() => {}">
              <el-form-item label="เลือกวันที่ต้องการ">
                <el-date-picker
                  v-model="datePick"
                  type="daterange"
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                ></el-date-picker>
                <el-button type="primary" style="margin-left:10px;" @click="fetchInvoicetList">ค้นหา</el-button>
                <el-button type="primary" style="margin-left:10px;" @click="refreshDatePick">ยกเลิก</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col class="text-md-right" :span="12" style="margin-bottom:5px;">
            <el-button :type="iconShowType === 'home' ? 'success' : 'danger'" @click="handelReuse"><fa-icon :name="iconShowType"></fa-icon></el-button>
          </el-col>
        </el-row>
        <el-row>
                <el-col :span="24">
                    <el-table
                        v-loading="loadingInvoiceList"
                        :data="invoiceItem"
                        stripe
                        :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                        style="width: 100%">
                        <el-table-column prop="createdAt"  label="วันที่ทำรายการ" width="180">
                            <template slot-scope="scope">
                                {{scope.row.createdAt | dayjs('format', 'YYYY-MM-DD HH:mm:ss')}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="durationDate" label="ช่วงวันที่เลือก" width="200"></el-table-column>
                        <el-table-column prop="fileName" label="ชื่อไฟล์" width="220"></el-table-column>
                        <el-table-column prop="name" label="ชื่อรายการ" min-width="100"></el-table-column>
                         <el-table-column prop="status" label="สถานะ" width="100">
                            <template slot-scope="scope">
                                {{ getPaymentStatus(scope.row.status) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="acceptDate" label="ยืนยันเมื่อ" width="200">
                            <template slot-scope="scope">
                                {{scope.row.approvedAt | dayjs('format', 'YYYY-MM-DD HH:mm:ss')}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="acceptDate" label="โดย" width="200">
                            <template slot-scope="scope">
                                {{scope.row.approvedBy}}
                            </template>
                        </el-table-column>
                        <el-table-column label="จัดการ" width="200" v-if="iconShowType==='recycle'">
                            <template slot-scope="scope">
                                <el-button-group>
                                    <el-button type="primary" size="small" @click="manageInvoice(scope.row)"><fa-icon name="folder"></fa-icon></el-button>
                                    <el-button type="danger" size="small" @click="deleteConfirmInvoice(scope.row)"><fa-icon name="trash-alt"></fa-icon></el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                        <el-table-column label="สาเหตุการลบ" width="200" v-if="iconShowType!=='recycle'">
                            <template slot-scope="scope">
                                <el-button-group>
                                    {{scope.row.deleteReason}}
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
                <el-col style="margin-top:10px;">
                <el-pagination
                    @size-change="changeLimitPage"
                    @current-change="changeCurrentPage"
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="10"
                    layout="prev, pager, next, sizes"
                    :total="pagination.allPage * pagination.limit">
                </el-pagination>
            </el-col>
            </el-row>
      </el-card>
    </el-col>
    <el-dialog
            class="dialogDeletePayment"
            title="ยืนยันการทำรายการ"
            :visible.sync="dialogDelete.confirmDialogVisible"
            width="30%"
            center>
            <el-form label-position="top" label-width="120px" @submit.native.prevent="() => {}">
                <el-form-item label="กรอกเหตุผลที่ลบรายการ">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        placeholder=""
                        v-model="dialogDelete.reasonDelete">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogDelete.confirmDialogVisible = false">ยกเลิก</el-button>
                <el-button type="primary" @click="deleteInvoice">ยืนยัน</el-button>
            </span>
        </el-dialog>
         <upload-file-excle
            :dialogShow="dialogShowaAddFile"
            @closeModalAddFileOrder="dialogShowaAddFile = false"
            @refreshInvoiceList="fetchInvoicetList"
        />
        <clear-running
            :dialogShow="dialogClearRunningNumber"
            @closeClearRunning="dialogClearRunningNumber = false"
        />
  </el-row>

</template>

<script>
import fgApi from '@/services/fillgoods'
import mixinPayment from '@/mixins/paymentUtility.js'
import UploadFileExcle from '@/components/Invoice/UploadFile'
import ClearRunning from '@/components/Invoice/DialogClearRunningNumber'
export default {
    name: 'PaymentList',
    mixins: [mixinPayment],
    components: {
        UploadFileExcle,
        ClearRunning
    },
    data () {
        return {
            datePick: null,
            dataTypeShow: 'default',
            iconShowType: 'recycle',
            invoiceItem: [],
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            dialogDelete: {
                invoiceId: null,
                confirmDialogVisible: false,
                reasonDelete: null
            },
            dialogShowaAddFile: false,
            dialogClearRunningNumber: false
        }
    },
    created () {
        this.$loading()
        let dateTo = new Date()
        let dateFrom = new Date()
        dateFrom.setDate(dateTo.getDate() - 14)
        this.datePick = [dateFrom, dateTo]
        this.fetchInvoicetList()
        this.$nextTick(() => {
            this.$loading().close()
        })
    },
    methods: {
        gotoUpload () {
            // this.$router.push({ path: '/oms/invoice/InvoiceUpload' })
            this.dialogShowaAddFile = !this.dialogShowaAddFile
        },
        async fetchInvoicetList () {
            this.loadingInvoiceList = true
            let dateFrom = this.datePick[0].getFullYear() + '-' + String(this.datePick[0].getMonth() + 1).padStart(2, '0') + '-' + String(this.datePick[0].getDate()).padStart(2, '0') + ' 00:00:00'
            let dateTo = this.datePick[1].getFullYear() + '-' + String(this.datePick[1].getMonth() + 1).padStart(2, '0') + '-' + String(this.datePick[1].getDate()).padStart(2, '0') + ' 23:59:59'
            let param = {
                from: dateFrom,
                to: dateTo,
                limit: this.pagination.limit,
                offset: this.pagination.offset
            }

            try {
                let res = []
                if (this.dataTypeShow === 'default') {
                    res = await fgApi.invoice.getListInvoice(param)
                } else {
                    res = await fgApi.invoice.getListInvoiceAllDeleted(param)
                }
                this.invoiceItem = res.data
                this.pagination.allPage = res.allPage
                console.log('fetch Invoice', res)
            } catch (error) {
                this.$message({
                    message: error,
                    type: 'error'
                })
                console.log('error ', error)
            }
            this.loadingInvoiceList = false
        },
        refreshDatePick () {
            this.$loading()
            let dateTo = new Date()
            let dateFrom = new Date()
            dateFrom.setDate(dateTo.getDate() - 14)
            this.datePick = [dateFrom, dateTo]
            this.fetchInvoicetList()
            this.$nextTick(() => {
                this.$loading().close()
            })
        },
        handelReuse () {
            this.pagination = { // reset กลับหน้าที่ 1
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            }

            if (this.dataTypeShow === 'default') {
                this.dataTypeShow = 'reuse'
                this.iconShowType = 'home'
            } else {
                this.iconShowType = 'recycle'
                this.dataTypeShow = 'default'
            }
            this.fetchInvoicetList()
        },
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchInvoicetList()
        },
        changeCurrentPage (val) {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            this.fetchInvoicetList()
        },
        manageInvoice (invoice) {
            console.log(invoice)
            this.$router.push({ path: `/oms/invoice/InvoiceUpload`, query: { invoiceId: invoice.invoiceId } })
        },
        deleteConfirmInvoice (invoice) {
            this.dialogDelete.confirmDialogVisible = true
            this.dialogDelete.reasonDelete = ''
            this.dialogDelete.invoiceId = invoice.invoiceId
        },
        async deleteInvoice () {
            let param = {
                invoice_id: this.dialogDelete.invoiceId,
                delete_reason: this.dialogDelete.reasonDelete
            }
            let loading = this.$loading({
                target: '.dialogDeletePayment'
            })
            try {
                let res = await fgApi.invoice.deleteInvoice(param)
                if (res.success) {
                    this.$message({
                        message: 'ลบข้อมูลเรียบร้อยแล้ว!',
                        type: 'success'
                    })
                    await this.fetchInvoicetList()
                } else {
                    throw new Error()
                }
            } catch (error) {
                this.$message({
                    message: 'Oops, Api is error.',
                    type: 'error'
                })
            }
            loading.close()
            this.dialogDelete.confirmDialogVisible = false
        },
        goClearRunningNumber () {
            this.dialogClearRunningNumber = !this.dialogClearRunningNumber
        }

    }
}
</script>
